// AUTO-GENERATED by scripts/codegen-analytics.cjs — do not edit by hand
// Source: src/analytics/schema.json

/** GA event names (action) aligned with main project */
export const GA_EVENT = {
  LEAD_OPEN: 'lead_open' as const,
  LEAD_SUBMIT_ATTEMPT: 'lead_submit_attempt' as const,
  LEAD_SUBMIT_SUCCESS: 'lead_submit_success' as const,
  LEAD_SUBMIT_ERROR: 'lead_submit_error' as const,
  LEAD_FORM_STEP_1_SUBMIT: 'lead_form_step_1_submit' as const,
  LEAD_FORM_STEP_2_SUBMIT: 'lead_form_step_2_submit' as const,
  LEAD_FORM_CONVERSION: 'lead_form_conversion' as const,
}

/** GA event categories */
export const GA_CATEGORY = {
  CONTACT: 'contact' as const,
  LEAD_FORM: 'lead_form' as const,
}

export type GaEventName = (typeof GA_EVENT)[keyof typeof GA_EVENT]
export type GaCategory = (typeof GA_CATEGORY)[keyof typeof GA_CATEGORY]

/** GTM dataLayer event names */
export const GTM_EVENT = {
  LEAD_FORM_SUBMIT: 'lead_form_submit' as const,
  LEAD_FORM_MODAL_OPEN: 'lead_form_modal_open' as const,
  BOST_FUNNEL_LEAD_FIELD_INTERACTION: 'bost_funnel_lead_field_interaction' as const,
  BOST_FUNNEL_LEAD_SUBMIT: 'bost_funnel_lead_submit' as const,
}

export type GtmEventName = (typeof GTM_EVENT)[keyof typeof GTM_EVENT]
